import { AssetsPage } from '@features/assets/components/AssetsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/assets/')({
    component: () => <AssetsPage kind="computers" />,
    staticData: {
        crumb: {
            label: 'Computers',
        },
    },
})
